module.exports = __webpack_public_path__ + "static/media/cookieman.041686b5.svg";